const primaryColor = "#086375"

export {
  primaryColor
}
